import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { WorkflowRule } from '../types';

// Bootstrap guard: requestStatus is 'Idle' (initial) or 'Loading' (API in flight)
// until INIT_PENCIL_SUCCESS resolves it to 'Success' or 'Error'.
// While in these transient states, suppress all workflow evaluation by returning IDLE
// so the loader remains visible and no premature navigation fires.
export const bootstrapIdleRule: WorkflowRule = (state: any): WorkflowStatus | null => {
    const requestStatus = state?.salesCheckin?.dealerships?.requestStatus;
    return requestStatus === ApiRequestStatus.Idle || requestStatus === ApiRequestStatus.Loading ? WorkflowStatus.IDLE : null;
};
